import _regeneratorRuntime from "@babel/runtime/helpers/regeneratorRuntime";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
var _div;
import { useState } from 'react';
import Trash2 from '@crehana/compass.icons.outline/Trash2';
import { Button, DialogClose, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from '@crehana/compass.ui/v2';
import { useLiveSessionsTranslation } from "../../../hooks/useLiveSessionsTranslation";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export var DeleteSessionModal = function DeleteSessionModal(_ref) {
  var sessionTitle = _ref.sessionTitle,
    onDelete = _ref.onDelete;
  var _useLiveSessionsTrans = useLiveSessionsTranslation(),
    t = _useLiveSessionsTrans.t;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    saving = _useState2[0],
    setSaving = _useState2[1];
  var handleDelete = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            setSaving(true);
            _context.next = 3;
            return onDelete()["finally"](function () {
              return setSaving(false);
            });
          case 3:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function handleDelete() {
      return _ref2.apply(this, arguments);
    };
  }();
  return /*#__PURE__*/_jsxs(DialogContent, {
    size: "sm",
    children: [/*#__PURE__*/_jsxs(DialogHeader, {
      children: [_div || (_div = /*#__PURE__*/_jsx("div", {
        className: "tw-w-5.6 tw-h-5.6 tw-bg-alert-100 tw-p-[6px] tw-rounded-full tw-mx-auto",
        children: /*#__PURE__*/_jsx("div", {
          className: "tw-w-full tw-h-full tw-bg-alert-200 tw-rounded-full tw-flex tw-items-center tw-justify-center",
          children: /*#__PURE__*/_jsx(Trash2, {
            size: 28,
            className: "tw-text-alert-500"
          })
        })
      })), /*#__PURE__*/_jsx(DialogTitle, {
        children: t('DELETE_SESSION_DIALOG_TITLE', {
          interpolation: {
            sessionTitle: sessionTitle
          }
        })
      })]
    }), /*#__PURE__*/_jsx(DialogDescription, {
      children: t('DELETE_SESSION_DIALOG_SUBTITLE')
    }), /*#__PURE__*/_jsxs(DialogFooter, {
      children: [/*#__PURE__*/_jsx(DialogClose, {
        asChild: true,
        children: /*#__PURE__*/_jsx(Button, {
          type: "submit",
          size: "sm",
          variant: "cancel",
          disabled: saving,
          children: t('DELETE_SESSION_DIALOG_CANCEL')
        })
      }), /*#__PURE__*/_jsx(Button, {
        type: "submit",
        size: "sm",
        onClick: handleDelete,
        disabled: saving,
        children: t('DELETE_SESSION_DIALOG_DELETE')
      })]
    })]
  });
};